import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CARGA_DIARIA } from '../../../../../config/tables'

function CargaDiariaView () {
  return (
    <MuiTable id={TABLA_CARGA_DIARIA} />
  )
}

export default CargaDiariaView
